import React from 'react';
import { isOwner } from '../../../../auth/redux/authActions';
import SidebarSection from '../SidebarSection/SidebarSection';
import get from 'lodash/get';

const Broker = ({ broker, source }) => {
  if (!isOwner()) {
    return null;
  }

  if (broker && broker.data.id && broker.data.attributes.broker_type === 'broker') {
    const brokerAttributes = broker.data.attributes;
    return <SidebarSection label={'Broker:'} info={<>{brokerAttributes.name}</>} />;
  }

  const sourceIsBroker = get(source, 'source.data.attributes.broker_type') === 'broker';
  if (source && sourceIsBroker) {
    return (
      <SidebarSection
        label={'Broker:'}
        info={
          <>
            {source.data.attributes.name}
            <br />
          </>
        }
      />
    );
  }

  return null;
};

export default Broker;
